module.exports = __webpack_public_path__ + "static/media/visitadiagnostica.7e2251c9.png";